import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, RotateCcw } from 'lucide-react';
import './AdvancedFiltersDrawer.css';

export default function AdvancedFiltersDrawer({ columns, filters, onChange, onClose }) {
  const handleClearAll = () => {
    onChange({});
  };

  const handleFilterChange = (columnKey, value) => {
    onChange({
      ...filters,
      [columnKey]: value
    });
  };

  const activeFiltersCount = Object.values(filters).filter(v => v).length;

  return (
    <AnimatePresence>
      <div className="filters-overlay" onClick={onClose}>
        <motion.div
          className="filters-drawer"
          onClick={(e) => e.stopPropagation()}
          initial={{ x: '100%' }}
          animate={{ x: 0 }}
          exit={{ x: '100%' }}
          transition={{ type: 'spring', damping: 25, stiffness: 200 }}
        >
          <div className="filters-drawer__header">
            <h2 className="filters-drawer__title">Filtros Avançados</h2>
            <button
              onClick={onClose}
              className="filters-drawer__close"
              aria-label="Fechar filtros"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          <div className="filters-drawer__body">
            {columns.map((column, index) => (
              <div key={index} className="filter-item">
                <label className="filter-item__label">
                  {column.header}
                </label>
                
                <input
                  type="text"
                  value={filters[column.accessorKey] || ''}
                  onChange={(e) => handleFilterChange(column.accessorKey, e.target.value)}
                  placeholder={`Buscar em ${column.header}...`}
                  className="filter-item__input"
                />
              </div>
            ))}
          </div>

          <div className="filters-drawer__footer">
            <button
              onClick={handleClearAll}
              className="filters-drawer__button filters-drawer__button--secondary"
            >
              <RotateCcw className="w-4 h-4" />
              Limpar Todos
            </button>
            <button
              onClick={onClose}
              className="filters-drawer__button filters-drawer__button--primary"
            >
              Aplicar {activeFiltersCount > 0 && `(${activeFiltersCount})`}
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}
